import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import StyleLink from "./dev/StyleLink";
import logoFooter from "./assets/img/logo_footer.png";
import facebookIcon from "./assets/img/facebook_icon.svg";
import mediumIcon from "./assets/img/medium_icon.svg";

const Footer = props => {
    const { messages } = props;
    const List = [
        { title: messages.nav_service, url: "/Pricing" },
        { title: messages.nav_contact, url: "/Contact" },
        { title: messages.footer_privacy_policy, url: "/PrivacyPolicy" },
        { title: messages.footer_term_of_service, url: "/TermofService" }
    ];
    return (
        <Container>
            <Content topItem>
                <img src={logoFooter} alt="" />
                <Title>{messages.footer_youTube}</Title>
            </Content>
            <ListWrap>
                {List.map(i => (
                    <StyleLink to={i.url} onClick={() => window.scrollTo(0, 0)}>
                        <Content>
                            <Title>{i.title}</Title>
                        </Content>
                    </StyleLink>
                ))}
            </ListWrap>
            <Content bottomItem>
                <IconWrap>
                    <StyleLink
                        to="https://www.facebook.com/InteRed.co/"
                        target="blank"
                    >
                        <Icon img={facebookIcon} size="65%" firstItem />
                    </StyleLink>
                    <StyleLink to="https://medium.com/@InteRed" target="blank">
                        <Icon img={mediumIcon} size="60%" />
                    </StyleLink>
                </IconWrap>
                <Title>Copyright©2018</Title>
            </Content>
        </Container>
    );
};
const mapStateToProps = state => {
    return {
        messages: state.Messages
    };
};
export default connect(mapStateToProps)(Footer);
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 10px 0 10px 180px;
    background-color: #666;
    z-index: 20000;
    @media (max-width: 1170px){
        padding-left: 0;
    }
`;
const Content = styled.div`
    display: flex;
    align-items: ${({ topItem }) => (topItem ? "flex-end" : "center")};
    justify-content: center;
    margin: 10px 0;
    padding: 0 16px;
    &:last-child {
        flex-direction: ${({ bottomItem }) => (bottomItem ? "column" : "")};
    }
    img {
        width: auto;
        height: 20px;
        margin-right: 10px;
    }
    @media (max-width: 665px) {
        align-items: center;
        flex-direction: column;
        width: 100%;
        padding: 20px 0;
        margin: 0;
        border-bottom: ${({ bottomItem }) =>
            bottomItem ? "" : "1px solid #979797"};
        img {
            margin-right: 0;
            margin-bottom: 10px;
        }
    }
`;
const Title = styled.span`
    display: flex;
    color: #fff;
    font-size: 12px;
    font-weight: 300;
    line-height: 12px;
`;
const ListWrap = styled.div`
    display: flex;
    align-items: center;
    a:nth-child(1) {
        cursor: pointer;
        ${Content} {
            border-left: 1px solid #fff;
        }
    }
    ${Content} {
        &:hover {
            ${Title} {
                font-weight: 500;
            }
        }
        border-right: 1px solid #fff;
    }
    @media (max-width: 665px) {
        width: 100%;
        flex-direction: column;
        a {
            width: 100%;
        }
        ${Content} {
            border-right: 0;
        }
        a:nth-child(1) {
            cursor: pointer;
            ${Content} {
                border-left: 0;
            }
        }
    }
`;
const IconWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const Icon = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    margin-bottom: 10px;
    border-radius: 100%;
    background-image: ${({ img }) => `url(${img})`};
    background-size: ${({ size }) => size};
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    ${({ firstItem }) => (firstItem ? "margin-right: 10px" : "")};
    @media (max-width: 665px) {
        width: 28px;
        height: 28px;
    }
`;



// WEBPACK FOOTER //
// ./src/Footer.js